import {useRef,useEffect} from 'react';
import {useThree} from '@react-three/fiber';

export const CameraControls = (props) => {
  // https://codeworkshop.dev/blog/2020-04-03-adding-orbit-controls-to-react-three-fiber/
  
  const {camera, gl:{domElement}, invalidate} = useThree();
  const controls = useRef();
  
  //dit werkt ongeveer om de camera-kijkplek in te stellen, maar net niet helemaal: zorgt voor irritant verspringen
  // useEffect(()=>{
  //   camera.lookAt(0, -100, 0)
  //   camera.updateProjectionMatrix()
  // })

  //this useEffect is to trigger rerender upon camera change
  //for performance reasons, the frameloop on Canvas is set to demand
  //only rendering when a React change is detected
  //Camera updates outside of React, so we attach a listener and call React Fiber's invalidate to trigger a manual frame
  useEffect(() => {
    // controls.current.addEventListener('change', invalidate)
    
    // if we don't capture the instance first, it may have been set to null, since it is mutable:
    // https://stackoverflow.com/questions/66022475/how-to-get-over-cannot-read-property-removeeventlistener-of-null-in-react
    const instance = controls.current; 
    instance.addEventListener('change', invalidate)
    return () => {
      instance.removeEventListener('change', invalidate)
    }
  }, [])

  return <orbitControls ref={controls} args={[camera, domElement]} />;

};